<div class="wrapper-select-filter-near-you">
  <div (click)="selectFollowinType(false)" class="wrapper-filter-box" [ngClass]="{'checked': !followingType}">
    <span>{{'NEAR_YOU_PAGE.show_all' | translate}}</span>
    <img class="icon-check" src="../../../../../assets/icons/outline/icon-check.svg" alt="">
  </div>
  <div (click)="selectFollowinType(true)"  class="wrapper-filter-box" [ngClass]="{'checked': followingType}">
    <span>
      {{'NEAR_YOU_PAGE.people_i_follow' | translate}}
    </span>
    <img class="icon-check" src="../../../../../assets/icons/outline/icon-check.svg" alt="">
  </div>
</div>
